export let MaterialLevel = /*#__PURE__*/function (MaterialLevel) {
  MaterialLevel["LEVEL0"] = "\uAE30\uD0C0";
  MaterialLevel["LEVEL1"] = "\uAC1C\uB150/\uC5F0\uC0B0";
  MaterialLevel["LEVEL2"] = "\uAE30\uBCF8 \uC720\uD615";
  MaterialLevel["LEVEL3"] = "\uC751\uC6A9/\uC2EC\uD654";
  MaterialLevel["LEVEL4"] = "\uD0AC\uB7EC \uC720\uD615";
  MaterialLevel["MIDTERM_TEST"] = "\uC911\uAC04\uAE30\uCD9C";
  MaterialLevel["FINAL_TEST"] = "\uAE30\uB9D0\uAE30\uCD9C";
  MaterialLevel["MOCK_TEST"] = "\uC218\uB2A5 \uBAA8\uC758\uACE0\uC0AC";
  return MaterialLevel;
}({});
export let StudyContentType = /*#__PURE__*/function (StudyContentType) {
  StudyContentType["MY_STUDY_MATERIAL"] = "my-study-materials";
  StudyContentType["MY_ASSIGNMENT"] = "my-assignments";
  StudyContentType["MY_TEST"] = "my-tests";
  StudyContentType["MY_WRONG_TEST"] = "my-wrong-tests";
  StudyContentType["MY_LEVEL_TEST"] = "my-level-tests";
  return StudyContentType;
}({});
export const TEST_STUDY_CONTENT_TYPE = new Set([StudyContentType.MY_TEST, StudyContentType.MY_WRONG_TEST, StudyContentType.MY_LEVEL_TEST]);
export let ElementarySchoolMathCourse = /*#__PURE__*/function (ElementarySchoolMathCourse) {
  ElementarySchoolMathCourse["PRIMARY1_1"] = "\uCD081-1";
  ElementarySchoolMathCourse["PRIMARY1_2"] = "\uCD081-2";
  ElementarySchoolMathCourse["PRIMARY2_1"] = "\uCD082-1";
  ElementarySchoolMathCourse["PRIMARY2_2"] = "\uCD082-2";
  ElementarySchoolMathCourse["PRIMARY3_1"] = "\uCD083-1";
  ElementarySchoolMathCourse["PRIMARY3_2"] = "\uCD083-2";
  ElementarySchoolMathCourse["PRIMARY4_1"] = "\uCD084-1";
  ElementarySchoolMathCourse["PRIMARY4_2"] = "\uCD084-2";
  ElementarySchoolMathCourse["PRIMARY5_1"] = "\uCD085-1";
  ElementarySchoolMathCourse["PRIMARY5_2"] = "\uCD085-2";
  ElementarySchoolMathCourse["PRIMARY6_1"] = "\uCD086-1";
  ElementarySchoolMathCourse["PRIMARY6_2"] = "\uCD086-2";
  ElementarySchoolMathCourse["PRIMARY"] = "\uCD08\uB4F1";
  return ElementarySchoolMathCourse;
}({});
export let MiddleSchoolMathCourse = /*#__PURE__*/function (MiddleSchoolMathCourse) {
  MiddleSchoolMathCourse["MIDDLE1_1"] = "\uC9111-1";
  MiddleSchoolMathCourse["MIDDLE1_2"] = "\uC9111-2";
  MiddleSchoolMathCourse["MIDDLE2_1"] = "\uC9112-1";
  MiddleSchoolMathCourse["MIDDLE2_2"] = "\uC9112-2";
  MiddleSchoolMathCourse["MIDDLE3_1"] = "\uC9113-1";
  MiddleSchoolMathCourse["MIDDLE3_2"] = "\uC9113-2";
  MiddleSchoolMathCourse["MIDDLE"] = "\uC911\uB4F1";
  return MiddleSchoolMathCourse;
}({});
export let HighSchoolMathCourse = /*#__PURE__*/function (HighSchoolMathCourse) {
  HighSchoolMathCourse["MATH_COMMON_1"] = "\uACF5\uD1B5\uC218\uD5591";
  HighSchoolMathCourse["MATH_COMMON_2"] = "\uACF5\uD1B5\uC218\uD5592";
  HighSchoolMathCourse["ALGEBRA"] = "\uB300\uC218";
  HighSchoolMathCourse["CALCULUS_1"] = "\uBBF8\uC801\uBD841";
  HighSchoolMathCourse["CALCULUS_2"] = "\uBBF8\uC801\uBD842";
  HighSchoolMathCourse["STATISTICS"] = "\uD655\uB960\uACFC \uD1B5\uACC4";
  HighSchoolMathCourse["GEOMETRY"] = "\uAE30\uD558";
  HighSchoolMathCourse["HIGH"] = "\uACE0\uB4F1";
  HighSchoolMathCourse["MATH_PREVIOUS"] = "\uC218\uD559(\uC0C1)";
  HighSchoolMathCourse["MATH_AFTER"] = "\uC218\uD559(\uD558)";
  HighSchoolMathCourse["MATH_1"] = "\uC218\uD5591";
  HighSchoolMathCourse["MATH_2"] = "\uC218\uD5592";
  HighSchoolMathCourse["CALCULUS"] = "\uBBF8\uC801\uBD84";
  return HighSchoolMathCourse;
}({});
export let USMathCourse = /*#__PURE__*/function (USMathCourse) {
  USMathCourse["US_PRE_ALGEBRA"] = "Pre-algebra";
  USMathCourse["US_ALGEBRA_1"] = "Algebra 1";
  USMathCourse["US_GEOMETRY"] = "Geometry";
  USMathCourse["US_ALGEBRA_2"] = "Algebra 2";
  USMathCourse["US_TRIGONOMETRY"] = "Trigonometry";
  USMathCourse["US_AP_PRE_CALCULUS"] = "AP Pre-calculus";
  USMathCourse["AP_CALCULUS_AB"] = "AP Calculus AB";
  USMathCourse["US_AP_CALCULUS_BC"] = "AP Calculus BC";
  USMathCourse["US_STATISTICS_AND_PROBABILITY"] = "Statistics & Probability";
  USMathCourse["US_AMC_8"] = "AMC 8";
  USMathCourse["US_AMC_10"] = "AMC 10";
  USMathCourse["US_AMC_12"] = "AMC 12";
  USMathCourse["US_BCA_PREP"] = "BCA Prep";
  USMathCourse["US_BOARDING_SHS_PREP"] = "Boarding/SHS Prep";
  USMathCourse["US_SAT_MATH"] = "SAT (Math)";
  USMathCourse["US_SAT_READING"] = "SAT (Reading)";
  USMathCourse["US_SAT_BLUEBOOK"] = "SAT Bluebook";
  USMathCourse["US_ACT"] = "ACT";
  USMathCourse["US_PSAT"] = "PSAT";
  USMathCourse["US_NJSLA_PARCC"] = "NJSLA/PARCC";
  USMathCourse["US_AP_STAT"] = "AP Stat";
  USMathCourse["US_AP_PHYSICS_1"] = "AP Physics 1";
  USMathCourse["US_AP_PHYSICS_2"] = "AP Physics 2";
  USMathCourse["US_AP_PHYSICS_C"] = "AP Physics C";
  USMathCourse["US_AP_CHEMISTRY"] = "AP Chemistry";
  USMathCourse["US_AP_BIOLOGY"] = "AP Biology";
  USMathCourse["US_AP_ENVIRONMENTAL_SCIENCE"] = "AP Environmental Science";
  USMathCourse["US_AP_COMPUTER_SCIENCE_A"] = "AP Computer Science A";
  USMathCourse["US_AP_COMPUTER_SCIENCE_PRINCIPLES"] = "AP Computer Science Principles";
  USMathCourse["US_1ST_GRADE"] = "1st grade";
  USMathCourse["US_2ND_GRADE"] = "2nd grade";
  USMathCourse["US_3RD_GRADE"] = "3rd grade";
  USMathCourse["US_4TH_GRADE"] = "4th grade";
  USMathCourse["US_5TH_GRADE"] = "5th grade";
  USMathCourse["US_6TH_GRADE"] = "6th grade";
  USMathCourse["US_7TH_GRADE"] = "7th grade";
  USMathCourse["US_8TH_GRADE"] = "8th grade";
  USMathCourse["US_MISC"] = "Misc.";
  USMathCourse["SH_PREP"] = "SH Prep";
  USMathCourse["US_PROBABILITY_AND_STATISTICS"] = "Probability & Statistics";
  USMathCourse["US_PRE_CALCULUS"] = "Pre-calculus";
  USMathCourse["US_CALCULUS"] = "Calculus";
  USMathCourse["US_BCA"] = "BCA";
  USMathCourse["US_SAT"] = "SAT";
  USMathCourse["AMC"] = "AMC";
  return USMathCourse;
}({});
export let EtcCourse = /*#__PURE__*/function (EtcCourse) {
  EtcCourse["ETC"] = "\uAE30\uD0C0";
  return EtcCourse;
}({});
export let MaterialType = /*#__PURE__*/function (MaterialType) {
  MaterialType["CONCEPT"] = "\uAC1C\uB150\uC5F0\uC0B0\uC11C";
  MaterialType["BASIC"] = "\uAE30\uBCF8\uC720\uD615\uC11C";
  MaterialType["PRACTICAL"] = "\uC751\uC6A9\uC2EC\uD654\uC11C";
  MaterialType["ADVANCED"] = "\uD0AC\uB7EC\uC720\uD615\uC11C";
  MaterialType["TEXTBOOK"] = "\uAD50\uACFC\uC11C";
  MaterialType["HANDOUT"] = "\uD559\uAD50\uD504\uB9B0\uD2B8";
  MaterialType["SCHOOL_TEST"] = "\uD559\uAD50\uAE30\uCD9C\uBB38\uC81C";
  MaterialType["SCHOOL_SUB_MATERIAL"] = "\uD559\uAD50\uBD80\uAD50\uC7AC";
  MaterialType["MOCK_TEST"] = "\uBAA8\uC758\uACE0\uC0AC";
  MaterialType["LEVEL_TEST"] = "\uC9C4\uB2E8\uD14C\uC2A4\uD2B8";
  MaterialType["CHAPTER_TEST"] = "\uB2E8\uC6D0\uD14C\uC2A4\uD2B8";
  MaterialType["TOTAL_TEST"] = "\uCD1D\uAD04\uD14C\uC2A4\uD2B8";
  MaterialType["DAILY_TEST"] = "\uB370\uC77C\uB9AC\uD14C\uC2A4\uD2B8";
  MaterialType["REVIEW_TEST"] = "\uBCF5\uC2B5\uD14C\uC2A4\uD2B8";
  MaterialType["ETC"] = "\uAE30\uD0C0";
  return MaterialType;
}({});
export let SubjectEnum = /*#__PURE__*/function (SubjectEnum) {
  SubjectEnum["MATHEMATICS"] = "\uC218\uD559";
  SubjectEnum["ENGLISH"] = "\uC601\uC5B4";
  return SubjectEnum;
}({});
export let StudyContentListOrderBy = /*#__PURE__*/function (StudyContentListOrderBy) {
  StudyContentListOrderBy["ID"] = "id";
  StudyContentListOrderBy["ID_DES"] = "-id";
  StudyContentListOrderBy["BOOK_MARK_UPDATED_AT"] = "bookMarkUpdatedAt";
  StudyContentListOrderBy["BOOK_MARK_UPDATED_AT_DES"] = "-bookMarkUpdatedAt";
  StudyContentListOrderBy["IS_BOOK_MARKED"] = "isBookmarked";
  StudyContentListOrderBy["IS_BOOK_MARKED_DES"] = "-isBookmarked";
  return StudyContentListOrderBy;
}({});
export let StudyMaterialClassificationType = /*#__PURE__*/function (StudyMaterialClassificationType) {
  StudyMaterialClassificationType["SUBJECT"] = "SUBJECT";
  StudyMaterialClassificationType["COURSE"] = "COURSE";
  StudyMaterialClassificationType["CHAPTER"] = "CHAPTER";
  StudyMaterialClassificationType["SECTION"] = "SECTION";
  return StudyMaterialClassificationType;
}({});
export let SelectStudyMaterialFormField = /*#__PURE__*/function (SelectStudyMaterialFormField) {
  SelectStudyMaterialFormField["SUBJECT"] = "subject";
  SelectStudyMaterialFormField["COURSE"] = "course";
  SelectStudyMaterialFormField["MATERIAL_TYPE"] = "materialType";
  SelectStudyMaterialFormField["MATERIAL_INFO"] = "materialInfo";
  SelectStudyMaterialFormField["TIME_LIMIT"] = "timeLimit";
  return SelectStudyMaterialFormField;
}({});